import {
  AccountStatus,
  AccountVerificationStatus,
  IAccount
} from "@wingspanhq/users/dist/lib/interfaces";

export const selectorAccountVerificationPending = (account: IAccount) =>
  account.status !== AccountStatus.Inactive &&
  (account.accountVerification?.status ===
    AccountVerificationStatus.Requested ||
    account.accountVerification?.status === AccountVerificationStatus.Pending);
